import BasisdatenVGV from "@/views/vgv/views/BasisdatenVGV.vue";
import GebaeudeausstattungVGV from "@/views/vgv/views/GebaeudeausstattungVGV.vue";
import VergleichVGV from "@/views/vgv/views/VergleichVGV.vue";
import IhreDatenVGV from "@/views/vgv/views/IhreDatenVGV.vue";
import AbschlussVGV from "@/views/vgv/views/AbschlussVGV.vue";
import BestaetigungVGV from "@/views/vgv/views/BestaetigungVGV.vue";
import routerUtils from "@/router/routerUtils";

const { pruefeDatenVorhanden } = routerUtils();

export default [
  {
    path: "",
    name: "VGV_Basisdaten_MaklerLink",
    component: BasisdatenVGV,
    props: { isMakler: true, isMaklerLink: true },
    meta: {
      title: "Wohngebäudeversicherung - Gebäudedaten | GEV-Versicherung",
    },
  },
  {
    path: "gebaeudeausstattung",
    name: "VGV_Gebaeudeausstattung_MaklerLink",
    component: GebaeudeausstattungVGV,
    props: { isMakler: true, isMaklerLink: true },
    meta: {
      title: "Wohngebäudeversicherung - Gebäudeausstattung | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/makler/vgv", "NEU"),
  },
  {
    path: "vergleich",
    name: "VGV_Vergleich_MaklerLink",
    component: VergleichVGV,
    props: { isMakler: true, isMaklerLink: true },
    meta: {
      title: "Wohngebäudeversicherung - Vergleich | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/makler/vgv", "NEU"),
  },
  {
    path: "ihre-daten",
    name: "VGV_IhreDaten_MaklerLink",
    component: IhreDatenVGV,
    props: { isMakler: true, isMaklerLink: true },
    meta: {
      title: "Wohngebäudeversicherung - Ihre Daten | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/makler/vgv", "NEU"),
  },
  {
    path: "abschluss",
    name: "VGV_Abschluss_MaklerLink",
    component: AbschlussVGV,
    props: { isMakler: true, isMaklerLink: true },
    meta: {
      title: "Wohngebäudeversicherung - Zusammenfassung und Abschluss | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/makler/vgv", "NEU"),
  },
  {
    path: "bestaetigung",
    name: "VGV_Bestaetigung_MaklerLink",
    component: BestaetigungVGV,
    props: { isMakler: true, isMaklerLink: true },
    meta: {
      title: "Wohngebäudeversicherung - Vielen Dank | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/makler/vgv"),
  },
];
